import {formatCurrency, formatDateTime} from "../common/Utils";
import React from "react";

export default function CafeOrderOptionItem({option, idx}) {

  return (
    <p key={idx} style={{
      fontSize: '0.85rem',
      lineHeight: '0.9rem'
    }}>
      <b>{option.optionGroupName}</b>
      <span style={{
        display: 'block'
      }}>
                                          {option?.options?.sort((a, b) => a.sortOrder - b.sortOrder)?.filter(copt => !copt?.specialInstructions && !copt?.scheduleDate)?.map((copt, idx) => {
                                            return (
                                              <span key={idx}><small>{idx === 0 ? '' : ', '}{copt.optionName}
                                                &nbsp;{copt.price > 0 ? <>(+{formatCurrency(copt.price)})</> : ''}</small></span>
                                            )
                                          })
                                          }

        {option?.options?.sort((a, b) => a.sortOrder - b.sortOrder)
          .filter(copt => copt?.scheduleDate && copt.scheduledAt?.length > 0)
          .map((copt, idx) => {
            return (
              <span key={idx} style={{
                display: 'block'
              }}><small><b>Preferred Time:</b> {formatDateTime(copt.scheduledAt)}</small>
                                                   </span>
            )
          })
        }
        {option?.options?.sort((a, b) => a.sortOrder - b.sortOrder)
          .filter(copt => copt?.specialInstructions && copt.instructions?.length > 0)
          .map((copt, idx) => {
            return (
              <span key={idx} style={{
                display: 'block'
              }}><small><b>Instructions:</b> {copt.instructions}</small>
                                                 </span>
            )
          })
        }

                                        </span>
    </p>
  )
}
